<template>
    <!-- 银行选择( 开户 或 添加 变更银行卡 时) -->
    <div class="wk-input wk-input-box dropDown-bank-box posi-relative">
        <span class="input-left-label">{{label}}</span>
        <!--下拉框的 显示框-->
        <div class="dropDown-title dropDown-bank posi-relative" 
            :class="{readonly:readonly===''}" @click="titleCliCk">
            <!-- 如果已经选择的某个银行 -->
            <template v-if="bankInfo.bankCode" >
                <img :src="imgUrl + 'static/img/bank-icon/'+bankInfo.bankCode+'.png'" 
                    class="dropDown-title-icon dropDown-bank"/>
                <p class="dropDown-title-bankName ft-size-16 dropDown-bank">
                    {{bankInfo.bankName}}
                </p>
            </template>
            <!-- 否则 未选择 提示请选择开户行 -->
            <p v-else class="dropDown-title-placeholder ft-size-16 dropDown-bank">请选择开户行</p>
            <!-- 在 readonly 下 启用 -->
            <p v-if="readonly===''" class="disabled posi-absolute"></p>
            <!-- 尾部 三角号 icon -->
            <p class="posi-absolute dropDown-title-sanjiao dropDown-bank">
                <img src="../../assets/img/dropdow-icon.png" class="dropDown-title-sanjiao dropDown-bank">
            </p>
        </div>
        <!--下拉框的选项-->
        <ul v-if="isShowBox && (!bankList || !bankList.length)" 
            class="dropDown-item-list posi-absolute flex dropDown-bank"  
            style="min-height:3rem;">
            <li class="dropDown-item not-data txt-gray" style="line-height:2.3rem;width:100%;display:block important;"> 
               暂无数据
            </li>
        </ul>
        <ul v-if="isShowBox && bankList && bankList.length" class="dropDown-item-list posi-absolute flex dropDown-bank" :style="styleCpt">
            <li  v-for="(item,k) in bankList" @click="itemClick(k)" :key='k' 
                :class="{active:k===bankIndex}" class="dropDown-item"> 
                <p class="dropDown-item">  
                    <img class="dropDown-item" :src="'../static/img/bank-icon/'+item.bankCode+'.png'"/> 
                </p>
                <p class="dropDown-item">{{item.bankFullName}}</p>
            </li>
        </ul>
    </div>			
</template>

<script>
    export default {
        props: ['label','value','id','styleCpt','readonly','queryType'],
        mounted(){
            this.initHandler(this);
        },
        data(){
            return{
                imgUrl:process.env.ASSETS_PUBLICPATH,
                bankList:'',
                bankInfo:'',
                bankIndex:'',
                isShowBox:false
            }
        },
        watch:{
            value(){
                // 一般是回显会用到
                if(this.bankInfo === '' && this.bankList){
                    this.showSltBank(this);
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('click', this.windowHanlderOfBank);
        },
        methods:{
            // title 单击事件
            titleCliCk(){
                this.isShowBox = !this.isShowBox;
            },
            // 银行选择事件
            itemClick(k){
                this.bankIndex = k;
                this.bankInfo = this.bankList[k];
                this.isShowBox = false;
                this.$emit('input',this.bankInfo);
            },
            // window 点击事件
            windowHanlderOfBank(e){
                let target = e.target;
                // 如果点击的 不是 title 和 item 都隐藏
                if( target.className.indexOf('dropDown-bank') < 0 ){
                    this.isShowBox = false;
                }
            },
            // 页面初始化数据
            initHandler(that){
                let obj = {}, url = 'account/open/banks';
                if(that.queryType == 'change'){ // 换卡
                    obj.tradeAcco = that.$tools.getSession("tkoltd_bankFn_tradeAcco");      
                    url = 'account/bank/change/list';           
                }else{ // 开户 增开 等
                    obj.queryType = that.queryType || '1';   
                }
                //获得银行卡列表
				that.$axios_post(url, obj).then((res)=>{
					console.log('银行卡列表00', res)
					if(res.code == '00000000'){
                        that.bankList = res.dataList;
                        // 如果已有默认选中的银行卡,则显示银行卡信息
                        that.showSltBank(that);
					}
                });
                // 绑定 window 事件
                window.addEventListener('click', this.windowHanlderOfBank);
            },
            // 显示的默认选中的银行卡信息
            showSltBank(that){
                if(that.value){
                    // 遍历出当前的 默认选中的 银行卡信息
                    that.bankList.map((val,k)=>{
                        if(val.bankCode == that.value.bankCode){
                            that.bankIndex = k;
                            that.bankInfo = val;
                            //跟新 当前银行卡的 开户方式
                            that.$store.commit('upBankInfo',{capitalInfoList:val.capitalInfoList})
                        }
                    })                              
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .dropDown-bank-box{
        margin:.9rem 0;
        // 下拉框的 title
        .dropDown-title{
            width: 17.3rem;
            height: 2.1rem;
            padding:0 .8rem;
            line-height: 2rem;
            border: 1px solid #d1d1d1;
            cursor:pointer; 
            // 未选择时提示
            .dropDown-title-placeholder{
                color:#cacaca;
            }
            // 已选择的银行 名称
            .dropDown-title-bankName{
                position: absolute;
                top:0;
                left:2.5rem;
            }
            // 已选择的银行 icon
            .dropDown-title-icon{
                max-width:1.2rem;
                margin-top:.4rem;  
            }
            // readonly 下启用
            p.disabled{
                top:0;
                right:0;
                width:18.4rem;
                height:2rem;
                background:rgba(245, 247, 250, .1);
                z-index: 3;
            }
            // 三角号的icon
            p:last-child{
                top:0;
                right:0;
                bottom:0;
                width:2rem;
                background: #F8F8F8;
                border-left:.05rem solid #D6D6D6;
                text-align: center;
            }
        }
        // 下拉选择项
        .dropDown-item-list{
            top:2.5rem;
            right:-3.4rem;
            width: 22rem;
            min-height:100px;
            padding:.2rem .5rem .5rem ;
            flex-wrap: wrap;
            background: #fff;
            border:.05rem solid #D1D1D1;
            box-shadow:0 2px 9px 0 rgba(205,200,200,0.48);
            z-index: 1000;
            li{
                display:flex !important;
                width:6.8rem;
                height: 2.3rem;
                padding:0 .4rem;
                margin:.3rem .2rem 0 0;
                border:.05rem solid transparent;
                cursor: pointer;
                transition: all .5s linear;
                // 银行 icon
                p:first-child{
                    padding-right:.3rem;
                    img{
                        max-width: 1.2rem;
                        margin-top:.55rem;
                    }
                }
                // 银行 名称
                p:last-child{
                    line-height: 2.3rem;
                }
            }
            li:nth-child(3n){
                margin-right:0;
            }
            li:hover,li.active{
                border:.05rem solid #DD867E;
                background:#FFF0EE;
            }
        }
        // readonly 模式下的 背景颜色
        .readonly{
            background: #F5F7FA; 
        }
    }
</style>
<style lang="less">
   .container-two .dropDown-bank-box {
       .dropDown-item-list{
           right:-2.3rem;
       }
   }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelectBank.vue